import { atom } from "recoil";

export const StatusDuAnState = atom({
  key: "StatusDuAnState",
  default: undefined,
});
